import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import PageHeader from '../PageHeader';
import Menu from '../Menu';
import GlobalVariable from '../../GlobalVariable';
import api from '../../api';
import {optimizedBenefitImageUrl} from './benefitImages';
import './BenefitCafe.scss';

type Benefit = {
    id: number;
    title: string;
    description: string;
    cost: number;
    url: string;
    category: string;
    status: boolean;
};

const categories = ['Медный', 'Бронзовый', 'Серебряный', 'Золотой', 'Платиновый'];

const exampleBenefits: Benefit[] = [{
    id: 0,
    title: 'Электронный сертификат OZON',
    description: 'Номинал 500 ₽',
    cost: 1000,
    url: '/img/benefit/ozon.webp',
    category: 'Медный',
    status: true
}, {
    id: 1,
    title: 'Электронный сертификат OZON',
    description: 'Номинал 700 ₽',
    cost: 1400,
    url: '/img/benefit/BenefitOZON.webp',
    category: 'Бронзовый',
    status: true
}, {
    id: 2,
    title: 'Сертификат на подписку Яндекс+',
    description: '3 месяца',
    cost: 2380,
    url: '/img/benefit/yandex.png',
    category: 'Серебряный',
    status: true
}, {
    id: 3,
    title: 'Набор косметики Чио Чио',
    description: 'Для ежедневного ухода за волосами',
    cost: 2000,
    url: '/img/benefit/bottle.png',
    category: 'Золотой',
    status: true
}, {
    id: 4,
    title: 'Набор косметики Чио Чио',
    description: 'Для ежедневного ухода за волосами',
    cost: 1500,
    url: '/img/benefit/bottle.png',
    category: 'Платиновый',
    status: true
}];

export class BenefitCafe extends Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {isLoad: false, isExample: false, benefits: []};
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        api({
            url: GlobalVariable.staffBack() + '/getBenefitsActive',
            method: 'GET',
            withCredentials: true
        })
            .then(result => {
                const benefits = Array.isArray(result.data) ? result.data : [];
                this.setState({
                    benefits: [...benefits].sort((a, b) => Number(a.cost) - Number(b.cost)),
                    isLoad: true
                });
            })
            .catch(() => {
                this.setState({
                    benefits: exampleBenefits,
                    isExample: true,
                    isLoad: true
                });
            });
    }

    renderBenefitCard(benefit: Benefit, priority: boolean) {
        const canRequest = benefit.category === 'Медный' && !this.state.isExample;

        return (
            <article key={benefit.id} className='benefit-prize-card'>
                <div className='benefit-prize-image'>
                    {benefit.url && <img
                        src={optimizedBenefitImageUrl(benefit.url)}
                        alt={benefit.title}
                        width='144'
                        height='132'
                        loading={priority ? 'eager' : 'lazy'}
                        decoding='async'
                    />}
                </div>
                <div className='benefit-prize-content'>
                    <h3>{benefit.title}</h3>
                    <p>{benefit.description}</p>
                    <div className='benefit-prize-footer'>
                        <span className='benefit-prize-cost'>
                            <img src='/img/icons/chiocoins.svg' width='16' height='16' alt=''/>
                            {benefit.cost}
                        </span>
                        {canRequest && <Link className='benefit-prize-action' to={'/benefit-cafe-get/' + benefit.id}>Получить</Link>}
                    </div>
                </div>
            </article>
        );
    }

    renderContent() {
        let imageIndex = 0;
        const benefits: Benefit[] = this.state.benefits.filter((benefit: Benefit) => benefit.status === true);

        return (
            <div className='benefit-cafe-content'>
                <section className='benefit-cafe-intro' aria-labelledby='benefit-cafe-intro-title'>
                    <div className='benefit-cafe-intro-top'>
                        <span className='benefit-cafe-intro-label'>Чиокоины → подарки</span>
                        <Link to='/chiocoins-history'>Мои чиокоины ›</Link>
                    </div>
                    <h2 id='benefit-cafe-intro-title'>Подарки за чиокоины</h2>
                    <p>Выполняй задания и проходи тесты — за это начисляются чиокоины. Здесь их можно обменять на реальные вещи и сертификаты.</p>
                    <div className='benefit-cafe-steps'>
                        <span><strong>Как получить:</strong> выбери приз, проверь баланс и нажми «Получить».</span>
                    </div>
                    <p className='benefit-cafe-delivery'>После заявки менеджер свяжется с тобой в течение 7 рабочих дней и расскажет, как получить приз.</p>
                </section>

                {this.state.isExample && <p className='benefit-cafe-example' role='status'>Каталог временно недоступен. Ниже показаны примеры подарков.</p>}

                {!this.state.isLoad ? (
                    <div className='benefit-cafe-loading' role='status' aria-label='Загружаем подарки'>
                        <div className='benefit-cafe-loading-title'/>
                        <div className='benefit-cafe-loading-card'/>
                        <div className='benefit-cafe-loading-card'/>
                    </div>
                ) : benefits.length === 0 ? (
                    <div className='benefit-cafe-empty'>Сейчас подарков нет. Загляни сюда позже.</div>
                ) : categories.map(category => {
                    const items = benefits.filter(benefit => benefit.category === category);
                    if (items.length === 0) return null;

                    return (
                        <section className='benefit-cafe-level' key={category} aria-label={category + ' уровень'}>
                            <h2 className='benefit-cafe-level-title'>{category} уровень</h2>
                            <div className='benefit-cafe-prizes'>
                                {items.map(benefit => this.renderBenefitCard(benefit, imageIndex++ < 2))}
                            </div>
                        </section>
                    );
                })}
            </div>
        );
    }

    render() {
        return (
            <div className='main lesson benefit-cafe-page'>
                <div className='content mx-w-content'>
                    <PageHeader pageTitle='Бенефит кафе' backBtnUrl='/'/>
                    <div className='pt-header'/>
                    {this.renderContent()}
                </div>
                <Menu/>
            </div>
        );
    }
}

export default BenefitCafe;
